import { render, staticRenderFns } from "./deliveryInformations.vue?vue&type=template&id=1b49f675"
import script from "./deliveryInformations.vue?vue&type=script&lang=js"
export * from "./deliveryInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports